import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { Observable, of } from 'rxjs';
import { API_KEY_PERMISSIONS, ApiKey, ApiKeySupplierMetadata, ApiKeyUpdateInput, Customer, FilterCriteria } from '../../../../model/models';
import { FilterBuilderComponent } from '../../../filter/filter-builder/filter-builder.component';
import { ApiKeysService } from '../api-keys.service';
import { SupplierMetadataEditorComponent } from '../supplier-metadata-editor/supplier-metadata-editor.component';

@Component({
  selector: 'api-key-configuration',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzFormModule, NzInputModule, NzSelectModule,
    NzTabsModule, NzAlertModule, NzTypographyModule, FilterBuilderComponent, SupplierMetadataEditorComponent],
  templateUrl: './api-key-configuration.component.html',
  styleUrl: './api-key-configuration.component.scss'
})
export class ApiKeyConfigurationComponent {
  @Input({ required: true }) apiKey!: ApiKey
  @Input({ required: true }) customer!: Customer
  @Output() back = new EventEmitter<void>()

  apiKeysService = inject(ApiKeysService)
  notification = inject(NzNotificationService)

  permissionOptions = API_KEY_PERMISSIONS

  isSaving = false

  persistFilter = (filter: FilterCriteria): Observable<FilterCriteria> => {
    this.apiKey.filter = filter
    return of(filter)
  }

  onSupplierMetadataChange(supplierMetadata: ApiKeySupplierMetadata[]): void {
    this.apiKey.supplier_metadata = supplierMetadata
  }

  update(): void {
    this.isSaving = true
    const payload: ApiKeyUpdateInput = {
      name: this.apiKey.name,
      description: this.apiKey.description,
      filter: this.apiKey.filter,
      permissions: this.apiKey.permissions,
      supplier_metadata: this.apiKey.supplier_metadata ?? []
    }
    this.apiKeysService.updateApiKey(this.customer.pk, this.apiKey.api_key_id, payload).subscribe({
      next: (res) => {
        this.apiKey = res
        this.isSaving = false
        this.notification.success('Success', 'API key updated')
      },
      error: () => {
        this.isSaving = false
        this.notification.error('Error', 'Failed to update API key')
      }
    })
  }
}
